import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Image, Typography, Table, Divider, Button } from 'antd';
import { useParams } from 'react-router-dom';
import { fetchViewDieQuotationById } from '../../slices/die-quotation';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as PrintIcon } from '../../Images/PrintIcon.svg';
import dayjs from 'dayjs';
import logo from '../../Images/logo.svg';

const PrintDiequotation2 = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const [quotationData, setQuotationData] = useState(null);
    const { user: currentUser } = useSelector(state => state.auth);
    const contentRef = useRef();

    const fetchData = async () => {
        try {
            const response = await dispatch(
                fetchViewDieQuotationById({ id: id }),
            ).unwrap();
            setQuotationData(response.results.data[0]);
        } catch (error) {
            console.error('Failed to fetch quotation:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [id]);

    const { Title, Text } = Typography;

    const columns = [
        {
            title: 'Sr. No.',
            dataIndex: 'SrNo',
            key: 'SrNo',
            align: 'center',
            render: (text, object, index) => {
                return index + 1;
            },
        },
        {
            title: 'Inq No.',
            dataIndex: 'inquiry_number',
            key: 'inquiry_number',
            align: 'center',
            render: (text, record) => {
                return (
                    <span>{record?.inquiry_number ? record?.inquiry_number : 'N/A'}</span>
                );
            },
        },
        {
            title: 'Profile No.',
            dataIndex: 'die_number',
            key: 'die_number',
            align: 'center',
            render: (text, record) => {
                return (
                    <span>
                        {record?.profile_no?.die_number
                            ? record?.profile_no?.die_number
                            : 'N/A'}
                    </span>
                );
            },
        },
        {
            title: 'Description',
            dataIndex: 'die_quotation_details',
            key: 'die_quotation_details',
            align: 'center',
            render: (text, record) => {
                const dimensions = [
                    record?.profile_no?.dimension1,
                    record?.profile_no?.dimension2,
                    record?.profile_no?.dimension3,
                    record?.profile_no?.dimension4,
                ]
                    .filter(dim => dim !== null && dim !== '' && dim !== undefined)
                    .map(dim => Number(dim).toFixed(2));

                if (dimensions.length === 0) return <span>N/A</span>;
                return (
                    <>
                        {dimensions.map((dim, index) => (
                            <div key={index}>
                                {dim} {index !== dimensions.length - 1 ? 'X' : ''}
                            </div>
                        ))}
                    </>
                );
            },
        },
        {
            title: 'Alloy',
            dataIndex: 'alloy',
            key: 'alloy',
            align: 'center',
            render: record => {
                return <span>{record?.name || 'N/A'}</span>;
            },
        },
        {
            title: 'Press Cap.',
            dataIndex: 'press_capacity',
            key: 'press_capacity',
            align: 'center',
        },
        {
            title: 'UoM',
            dataIndex: 'unit_of_measurement',
            key: 'unit_of_measurement',
            align: 'center',
        },
        {
            title: 'Qty',
            dataIndex: 'quantity',
            key: 'quantity',
            align: 'center',
        },
        {
            title: 'Basic',
            dataIndex: 'profile_devlopment_cost',
            key: 'profile_devlopment_cost',
            align: 'right',
        },
        {
            title: 'CGST',
            key: 'cgst',
            align: 'right',
            render: record => {
                const cgst = record?.profile_devlopment_cost
                    ? (record.profile_devlopment_cost * 9) / 100
                    : 0;
                return <span>{cgst.toFixed(2) || 'N/A'}</span>;
            },
        },
        {
            title: 'SGST',
            key: 'sgst',
            align: 'right',
            render: record => {
                const sgst = record?.profile_devlopment_cost
                    ? (record.profile_devlopment_cost * 9) / 100
                    : 0;
                return <span>{sgst.toFixed(2) || 'N/A'}</span>;
            },
        },
        {
            title: 'Total (Rs.)',
            key: 'total',
            align: 'right',
            render: record => {
                const basicAmount = record?.profile_devlopment_cost || 0;
                const sgst = (basicAmount * 9) / 100;
                const cgst = (basicAmount * 9) / 100;
                const totalAmount = basicAmount + sgst + cgst;
                return <span>{totalAmount.toFixed(2) || 'N/A'}</span>;
            },
        },
    ];
    const printStyles = `
@media print {
  @page {
    size: A4 portrait;
    margin: 5mm;
  }

  body {
    font-size: 9px !important;
    margin: 0;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color-adjust: exact !important;
  }
  
  .print-container {
    width: 100% !important;
    max-width: 210mm !important;
    box-sizing: border-box !important;
    position: relative !important;
    border: 2px solid #12406a !important;
    margin: 0 !important;
    padding: 8px !important;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%) !important;
  }
  
  .page {
    page-break-after: always !important;
    position: relative !important;
    box-sizing: border-box !important;
    overflow: hidden !important;
  }
  
  .page-content {
    width: 100% !important;
    overflow: hidden !important;
  }
  
  .signature-section {
    font-size: 9px !important
    margin-top: 5px !important;
    page-break-inside: avoid !important;
    page-break-before: avoid !important;
    break-inside: avoid !important;
  }

  .header-section {
    background-color:white !important;
    border-radius: 8px !important;
    padding: 10px !important;
    margin-bottom: 15px !important;
    box-shadow: 0 2px 8px rgba(18, 64, 106, 0.2) !important;
  }

  .info-card {
    background: #ffffff !important;
    border: 1px solid #e1e8ed !important;
    border-radius: 6px !important;
    padding: 8px !important;
    margin-bottom: 8px !important;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
  }

  .info-card-header {
    background: linear-gradient(90deg, #12406a 0%, #1e5a8a 100%) !important;
    color: white !important;
    padding: 4px 8px !important;
    margin: -8px -8px 6px -8px !important;
    border-radius: 5px 5px 0 0 !important;
    font-weight: bold !important;
    font-size: 10px !important;
  }

  .quotation-details {
    background: #f8f9fa !important;
    border: 1px solid #12406a !important;
    border-radius: 6px !important;
    padding: 6px !important;
  }

  .bank-details-card {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
    border: 1px solid #12406a !important;
    border-radius: 6px !important;
    padding: 8px !important;
    margin-top: 10px !important;
  }
  
  .ant-row {
    display: flex !important;
    flex-wrap: wrap !important;
  }
  
  .ant-col-md-12 { width: 50% !important; }
  .ant-col-md-8 { width: 33.33% !important; }
  .ant-col-md-10 { width: 41.66% !important; }
  .ant-col-md-6 { width: 25% !important; }
  .ant-col-24 { width: 100% !important; }
  .ant-col-md-16 { width: 66.66% !important; }
  
  .ant-col {
    box-sizing: border-box;
    padding: 2px;
  }
  
  h1, h2, h3, h4, h5 {
    color: #12406a !important;
    margin-bottom: 4px !important;
  }
  
  .ant-table {
    width: 100% !important;
    font-size: 11px !important;
    table-layout: fixed !important;
    border-radius: 6px !important;
    overflow: hidden !important;
  }
  
  .ant-table-container {
    overflow: visible !important;

    padding: 0px !important;
  }
  
  .ant-table-wrapper {
    padding: 0 !important;
    overflow: visible !important;
  }
  
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 1px 1px !important; 
    font-size: 8px !important;
    background-color: white !important;
    border: 1px solid #d9d9d9 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    word-break: break-word !important;
  }

  .kind_attention{
    margin-right:65px;
  }
  
  .ant-table-thead > tr > th {
    background: linear-gradient(135deg, #12406a 0%, #1e5a8a 100%) !important;
    color:white !important;
    font-weight: bold !important;
    text-align: center !important;
  }
  
  .ant-table-wrapper .ant-table-summary > tr > td {
    border-inline-start: 1px solid #f0f0f0;
    border-top: 1px solid #f0f0f0;
    border-bottom: 1px solid #f0f0f0;
    padding: 1px !important;
    font-size: 8px !important;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
  }
  
  .summary-cell-center {
    text-align: center !important;
  }
  
  .summary-cell-right {
    text-align: right !important;
    padding-right: 5px !important;
  }
  
  .ant-divider {
    margin: 8px 0 !important;
    border-top: 1px solid #d9d9d9 !important;
  }
  
  .no-print {
    display: none !important;
  }
  
  .terms-page {
    padding: 2px !important;
    border: 1px solid black !important;
    margin: 0 !important;
    page-break-before: auto !important;
  }

  .terms-heading {
     font-size: 0.5px !important; 
  }
  
  .terms__content {
    font-size: 6px !important;
    text-align: justify !important;
    line-height: 1.3 !important;
    max-width: 100% !important;
    margin: 0 auto !important;
    padding: 0 5px !important;
  }

   .terms__content h3{
    font-weight: 600 !important;
  }

  img {
    max-width: 100% !important;
  }

  .signature-card {
    background: #f8f9fa !important;
    border: 1px solid #12406a !important;
    border-radius: 6px !important;
    padding: 10px !important;
    text-align: center !important;
    height:130px;
  }
}

div[style*="backgroundColor: #12406a"] {
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
  color-adjust: exact !important;
  background-color: #12406a !important;
}
`;


    useEffect(() => {
        const styleEl = document.createElement('style');
        styleEl.innerHTML = printStyles;
        document.head.appendChild(styleEl);

        return () => {
            document.head.removeChild(styleEl);
        };
    }, []);

    const handlePrint = () => {
        window.print();
    };

    return (
        <>
            <div className="print-container page" ref={contentRef} style={{ padding: 10 }}>
                <div className="page-content">
<div className="header-section">
                        <Row justify="space-between" align="middle">
                            <Col span={16}>
                                <Title level={1} style={{ color: 'white', margin: 0, fontSize: '28px', fontWeight: 'bold' }}>
                                    Die Quotation
                                </Title>
                            </Col>
                            <Col span={8} style={{ textAlign: 'right' }}>
                                <img src={logo} alt="Company Logo" style={{ maxWidth: '120px', maxHeight: '60px' }} />
                            </Col>
                        </Row>
                    </div>
<Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
                        <Col span={12}>
                            <div style={{
                                border: '1px solid #dcdde1',
                                borderRadius: '6px',
                                padding: '12px',
                                backgroundColor: '#f9f9f9',
                                height: '100%'
                            }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                                    <div>
                                        <Text strong style={{ color: '#12406a', fontSize: '12px' }}>Date:</Text><br />
                                        <Text style={{ fontSize: '11px', fontWeight: '500' }}>
                                            {quotationData?.quotation_date
                                                ? dayjs(quotationData.quotation_date).format('DD-MM-YYYY')
                                                : 'N/A'}
                                        </Text>
                                    </div>
                                    <div style={{ textAlign: 'right' }}>
                                        <Text strong style={{ color: '#12406a', fontSize: '12px' }}>Quotation No:</Text><br />
                                        <Text style={{ fontSize: '11px', fontWeight: 'bold' }}>
                                            {quotationData?.quotation_no || 'N/A'}
                                        </Text>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div style={{
                                border: '1px solid #dcdde1',
                                borderRadius: '6px',
                                padding: '12px',
                                backgroundColor: '#f9f9f9',
                                height: '100%'
                            }}>
                                <div style={{
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    marginBottom: '4px',
                                    color: '#34495e'
                                }}>
                                    Kind Attention
                                </div>
                                <Text style={{ fontSize: '11px', fontWeight: 'bold', color: '#12406a' }}>
                                    {quotationData?.customer?.contact_persons?.[0]?.contact_person_name || 'N/A'}
                                </Text>
                                <br />
                                <Text style={{ fontSize: '10px', color: '#2f3640' }}>
                                    {quotationData?.customer?.contact_persons?.[0]?.contact_person_mobile_number
                                        ? `+${quotationData.customer.contact_persons[0].contact_person_mobile_number}`
                                        : 'N/A'}
                                </Text>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={[16, 8]} style={{ marginBottom: '20px' }}>
                        <Col span={12}>
                            <div style={{
                                border: '1px solid #dcdde1',
                                borderRadius: '6px',
                                padding: '12px',
                                backgroundColor: '#f9f9f9',
                                height: '100%'
                            }}>
                                <div style={{
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    marginBottom: '4px',
                                    color: '#34495e'
                                }}>
                                    Bill To
                                </div>
                                <Text style={{ fontSize: '11px', fontWeight: 'bold', color: '#12406a' }}>
                                    {quotationData?.customer?.customer_name}
                                </Text>
                                <br />
                                <Text style={{ fontSize: '9px', lineHeight: '1.4', color: '#555' }}>
                                    {quotationData?.customer?.office_address?.shop},{' '}
                                    {quotationData?.customer?.office_address?.area},{' '}
                                    {quotationData?.customer?.office_address?.landmark}<br />
                                    {quotationData?.customer?.office_address?.city}{' '}
                                    {quotationData?.customer?.office_address?.state} -{' '}
                                    {quotationData?.customer?.office_address?.pin_code}
                                </Text>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div style={{
                                border: '1px solid #dcdde1',
                                borderRadius: '6px',
                                padding: '12px',
                                backgroundColor: '#f9f9f9',
                                height: '100%'
                            }}>
                                <div style={{
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    marginBottom: '4px',
                                    color: '#34495e'
                                }}>
                                    Ship To
                                </div>
                                <Text style={{ fontSize: '11px', fontWeight: 'bold', color: '#12406a' }}>
                                    {quotationData?.customer?.customer_name}
                                </Text>
                                <br />
                                <Text style={{ fontSize: '9px', lineHeight: '1.4', color: '#555' }}>
                                    {quotationData?.customer?.factory_address?.shop},{' '}
                                    {quotationData?.customer?.factory_address?.area},{' '}
                                    {quotationData?.customer?.factory_address?.landmark}<br />
                                    {quotationData?.customer?.factory_address?.city}{' '}
                                    {quotationData?.customer?.factory_address?.state} -{' '}
                                    {quotationData?.customer?.factory_address?.pin_code}
                                </Text>
                            </div>
                        </Col>
                    </Row>
<div style={{ width: '100%' }}>
                        <Table
                            style={{ width: '100%', tableLayout: 'fixed' }}
                            bordered
                            size="small"
                            dataSource={quotationData?.die_quotation_details || []}
                            columns={columns}
                            pagination={false}
                            rowKey={(record, index) => `row-${index}`}
                            summary={pageData => {
                                return (
                                    <>
                                        <Table.Summary.Row>
                                            <Table.Summary.Cell
                                                index={0}
                                                colSpan={7}
                                                style={{ textAlign: 'center' }}
                                                className="summary-cell-center"
                                            >
                                                <b>Total </b>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={7}>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <b>{quotationData?.summary?.total_quantity || 'N/A'}</b>
                                                </div>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={8} style={{ textAlign: 'center' }}>
                                                <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
                                                    <b>{quotationData?.summary?.total_basic_amount || 'N/A'}</b>
                                                </div>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={9} style={{ textAlign: 'center' }}>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={10} style={{ textAlign: 'center' }}>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell index={11} style={{ textAlign: 'center' }}>
                                                <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
                                                    <b>
                                                        {quotationData?.summary?.total_amount_with_gst || 'N/A'}
                                                    </b>
                                                </div>
                                            </Table.Summary.Cell>
                                        </Table.Summary.Row >
                                    </>
                                );
                            }}
                        />
                    </div>
<Row justify="end">
                        <Col span={12}>
                            <div className="bank-details-card">
                                <Title level={5} style={{ color: '#12406a', margin: '0 0 8px 0', fontSize: '12px' }}>
                                    Bank Details
                                </Title>
                                <div style={{ fontSize: '9px', lineHeight: '1.4' }}>
                                    <Text><b>GST No:</b> {quotationData?.customer?.gstin_number || 'N/A'}</Text><br />
                                    <Text><b>Bank:</b> {quotationData?.customer?.customer_banking_details?.[0]?.bank_name || 'N/A'}</Text><br />
                                    <Text><b>Branch:</b> {quotationData?.customer?.customer_banking_details?.[0]?.bank_branch_address || 'N/A'}</Text><br />
                                    <Text><b>A/C:</b> {quotationData?.customer?.customer_banking_details?.[0]?.bank_account_number || 'N/A'}</Text><br />
                                    <Text><b>IFSC:</b> {quotationData?.customer?.customer_banking_details?.[0]?.bank_ifsc_code || 'N/A'}</Text>
                                </div>
                            </div>
                        </Col>
                    </Row>
<div className="signature-section">
                        <Row gutter={[16, 0]} style={{ marginTop: '20px' }}>
                            <Col span={12}>
                                <div className="signature-card">
                                    <div style={{ height: '60px', borderBottom: '1px solid #12406a', marginBottom: '8px' }}></div>
                                    <Title level={5} style={{ color: '#12406a', margin: 0, fontSize: '11px' }}>
                                        Prepared By
                                    </Title>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="signature-card">
                                    <div style={{ height: '60px', borderBottom: '1px solid #12406a', marginBottom: '8px' }}></div>
                                    <Title level={5} style={{ color: '#12406a', margin: 0, fontSize: '11px' }}>
                                        Authorised Signatory
                                        <br />
                                        (Alux ERP)
                                    </Title>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>

            <div className="terms-page page" style={{ padding: 15 }}>
                <Row justify="center">
                    <Title level={5} style={{ color: '#12406a', margin: '5px 0 10px 0', fontSize: '20px', fontWeight: '700' }}>
                        Terms & Conditions
                    </Title>
                </Row>
                <Row>
                    <Col span={24}>
                        <div
                            className="terms__content"
                            style={{
                                width: '100%',
                                lineHeight: '1.3',
                                textAlign: 'justify',
                                maxWidth: '100%'
                            }}
                            dangerouslySetInnerHTML={{
                                __html:
                                    quotationData?.terms_and_condition
                                        ?.replace(/<p>(&nbsp;|\s)*<\/p>/gi, '')
                                        .replace(/\s+/g, ' ')
                                        .trim() || 'Terms and conditions not available',
                            }}
                        ></div>
                    </Col>
                </Row>
            </div>

            <div
                className="no-print"
                style={{ textAlign: 'center', marginTop: '20px', padding: '0 15px' }}
            >
                <Button type="primary" onClick={handlePrint} icon={<PrintIcon />}>
                    Print
                </Button>
            </div>
        </>
    );
};

export default PrintDiequotation2;